export default __webpack_public_path__ + "static/media/CrepusculeForNellie60s.75fe76fe.mp3";